export default __webpack_public_path__ + "static/media/submit1.1ab1257c.png";